<div id ="printArea" class="text-center print-font print-scale">
  <div class="div-print-format">
    <!-- 帳票印刷画像 -->
    <img class="print-format-image" :src="printFormatSrc" draggable="false" />
    <!-- ヘッダ情報 -->
    <div class="print-absolute print-header-date">{{ inspectionDate }}</div>
    <div class="print-absolute print-header-vin">{{ vehicleVinProp }}</div>
    <div class="print-absolute print-header-user">{{ userInfoProp.name }}</div>
    <div class="print-absolute print-header-mileage">{{ mileage }}</div>

    <!-- カテゴリ一覧表 -->
    <div v-for="(system, index) in resultFormGroupSystems" :key="index" :class="['print-absolute', `category-box`, `category-box-font`, system.systems ? resultNgCss : '']" :style="system.style">
      <div v-if="system.is_display">
        <div class="ml-1">{{ $t(`printFormat.${index}`) }}</div>
        <div class="ml-1">
          <svg v-if="system.systems" viewBox="0 0 18 18" class="icon">
            <path
              d="M 16 8 A 8 8 0 1 1 0 8 a 8 8 0 0 1 16 0 m -12.049 -5.5 c 0.234 -0.404 -1.703 1.488 -1.683 1.485 L 6.399 7.887 l -4 4 c 0 0 1.449 1.252 1.704 1.485 L 7.993 9.482 l 4 4 c 0 0 0.869 -0.818 1.549 -1.534 L 9.482 8.015 l 4 -4 c 0.007 -0.026 -0.718 -0.81 -1.428 -1.528 L 8.044 6.358 z"
              fill="#FF0000" />
          </svg>
          <svg v-else viewBox="0 0 16 16" class="icon">
            <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1z" fill="#00B050" />
            <path
              d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"
              fill="white" />
          </svg>
        </div>
        <div class="ml-1">{{ system.systems }}</div>
      </div>
    </div>

    <!-- 結果一覧表 -->
    <div class="print-absolute print-result-table">
      <div class="row">
        <!-- 判定表 -->
        <template v-for="(tableItems, tableIndex) in [resultLeftTableItems, resultRightTableItems]" :key="tableIndex">
          <div v-if="tableItems.length > 0" class="col-6">
            <table class="result-table-style overflow-auto">
              <tr>
                <th class="table-categories-width">{{ $t('printFormat.19') }}</th>
                <th class="table-no-width">{{ $t('printFormat.20') }}</th>
                <th class="table-results-width">{{ $t('printFormat.21') }}</th>
                <th>{{ $t('printFormat.22') }}</th>
              </tr>
              <tr v-for="(column, index) in tableItems" :key="index">
                <!-- カテゴリ（帳票グループ） -->
                <td v-if="column.form_group_count > 0" :rowspan="column.form_group_count" :class="column.is_form_group_ng ? resultNgCss : ''">{{ 
                  column.form_group_name }}</td>
                <td v-else style="display: none;"></td>
                <!-- システム番号 -->
                <td :class="column.is_system_ng ? resultNgCss : ''">{{ column.system_no }}</td>
                <!-- システム判定画像 -->
                <td>
                  <svg v-if="column.is_system_ng" viewBox="-1 -1 18 18" class="small-icon">
                    <path
                      d="M 16 8 A 8 8 0 1 1 0 8 a 8 8 0 0 1 16 0 m -12.049 -5.5 c 0.234 -0.404 -1.703 1.488 -1.683 1.485 L 6.399 7.887 l -4 4 c 0 0 1.449 1.252 1.704 1.485 L 7.993 9.482 l 4 4 c 0 0 0.869 -0.818 1.549 -1.534 L 9.482 8.015 l 4 -4 c 0.007 -0.026 -0.718 -0.81 -1.428 -1.528 L 8.044 6.358 z"
                      fill="#FF0000" />
                  </svg>
                  <svg v-else viewBox="0 0 16 16" class="small-icon">
                    <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1z" fill="#00B050" />
                    <path
                      d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"
                      fill="white" />
                  </svg>
                </td>
                <!-- システム名 -->
                <td :class="column.is_system_ng ? resultNgCss : ''">{{ column.system_name }}</td>
              </tr>
            </table>
          </div>
        </template>
      </div>
    </div>
  </div>
</div>